import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';

import { environment } from '../../environments/environment';

export interface Datos {
  ok?: boolean;
  prueba?: string;
  usuarios?: any;
}

@Injectable({
  providedIn: 'root'
})
export class InicioService {

  urlBase: string = environment.apiEndpoint;
  constructor(  private httpClient: HttpClient ) { }

  prueba (){
    let headers = new Headers({
      'Content-Type' : 'application/json'
    });

    return this.httpClient.get( this.urlBase)
    .pipe(map( res => {
      console.log(res);
      return res;
    }));
  }

  pruebaZip(forma){
    return this.httpClient.post( this.urlBase + 'upload', forma);
  }

  validaRFC(form) {

    // headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post( this.urlBase + 'rfc', form);
  }

  enviaArchivos ( form, rfc , idContratista) {
    return this.httpClient.post(this.urlBase + 'upload/' + rfc + '/' + idContratista, form);
  }

   // ----------------------------------
  // ----------------------------------
  // ----------------------------------
  // Login
  // ----------------------------------
  // ----------------------------------
  // ----------------------------------

  iniciarSesion(form) {
    return this.httpClient.post(this.urlBase + 'inicio/login', form);
  }

  validarSessionTkn(token) {
    return this.httpClient.post(this.urlBase + `inicio/validar-sessionTkn?token=${token}`, token);
  }

  // ----------------------------------
  // ----------------------------------
  // ----------------------------------
  // Recuperar password
  // ----------------------------------
  // ----------------------------------
  // ----------------------------------

  
  recuperarPassword ( datos) {
    return this.httpClient.post(`${this.urlBase }inicio/recuperar-password`, datos);
  }

  isTokenValid(token) {
    return this.httpClient.post(`${this.urlBase }inicio/validar-token?token=${token}`, token );
  }

  nuevoPassword(form, token) {
     let datos = {password: form.password,
     confirmacion: form.validaPassword}
    return this.httpClient.post(`${this.urlBase }inicio/nuevo-password?token=${token}`, datos );
  }
}
